import { IMessageBroker } from "@sparkware/uc-sdk-core";
import { MB_HEADERS } from "./externalCommunication";

export default function publishLogout(messageBroker: IMessageBroker) {
  messageBroker.identity.topics.logout.publish(MB_HEADERS, {});
}
